import { useCallback, useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useParams } from 'react-router-dom'

import { Note } from '@components/note'
import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft'
// import LibraryAddCheckOutlinedIcon from '@mui/icons-material/LibraryAddCheckOutlined'
import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined'
import { ConfirmModal } from '@components/common'

import { useRevertedInvoice } from '@caradasstore/InvoiceEditStore'
import { useLoadingStore } from '@caradasstore/LoadingStore'
import { AssignedUser } from '@components/assigned-user'
import { CarImageHolder } from '@components/car-image-holder'
import { CustomItem } from '@components/custom-item'
import { Drawers } from '@components/drawers'
import { IdDisplay } from '@components/id-display'
import {
  AdasBox,
  AdasButton,
  AdasContainer,
  AdasDivider,
  AdasImage,
  AdasModal,
  AdasPaper,
  AdasStack,
  AdasStep,
  AdasStepLabel,
  AdasStepper,
  AdasTextField,
  AdasTypography
} from '@components/wrapper-components'
import {
  convertToStandardWO,
  convertWorkOrderToInvoice,
  deleteWorkOrder,
  getCalibrationList,
  getQWIByWorkOrderId,
  getServiceList,
  getWorkOrderByReferenceNumber,
  updateNote,
  updateWorkOrderCalibrations,
  updateWorkOrderServices,
  updateClient,
  getPartsList,
  getLabourList,
  updateWorkOrderParts,
  updateWorkOrderLabour,
  getReferralByCode
} from '../../../api/api'
import { Logger } from '../../../logger'
import { useScrollTop } from '../../../utils/useScrollTop'
import { currencyFormatter } from '../../../utils/utils'
import { useUserStore } from '@caradasstore/UserStore'
import { SyncAltOutlined } from '@mui/icons-material'
import { GENERIC_MESSAGES, BUTTONS_DISPLAY_LABEL, PARAM_NAMES, REDIRECT_URLS, getUrlByNameAndId } from '../../../constants'
import { StatusEnum } from '../../../enums/enums'
import { DropdownActionButtons } from '@components/buttons'
import { EmailForm } from '@components/email'
import { getWorkorderEmailPreview, getWorkorderPdf } from '../../../api/api'
import ExpandableSection from '@components/custom-item/item-list/ExpandableSection'
import { EditProductPricing } from '@components/product/edit-product-pricing/EditProductPricing'
import theme from 'theme/theme'
import { useEditPricing } from '../../../hooks/useEditPricing'
import { flattenItem, transformToMap } from '../../../utils/itemHelpers'
import { handleDrawerClose } from '../../../hooks/handleDrawerClose'
import { MAX_DESCRIPTION_LENGTH } from '../../../constants'
import { itemHandlersFactory } from 'utils/populateItemsUtil'
import { ProductContractBanner } from '@components/product'
export const WorkOrderSummaryPage = () => {
  useScrollTop()
  const { [PARAM_NAMES.REFERENCE_NUMBER]: referenceNumber } = useParams()
  const [packages, setPackages] = useState([])
  const [services, setServices] = useState([])
  const [parts, setParts] = useState([])
  const [labor, setLabor] = useState([])
  const [availableCalibrations, setAvailableCalibrations] = useState() // previously allCalibrations
  const [availableServices, setAvailableServices] = useState() // previously allServices
  const [availableParts, setAvailableParts] = useState() // previously allParts
  const [availableLabour, setAvailableLabour] = useState() // previously allLabour

  const [isCalibrationOpen, setIsCalibrationOpen] = useState(false)
  const [isServiceOpen, setIsServiceOpen] = useState(false)
  const [isPartsOpen, setIsPartsOpen] = useState(false)
  const [isLabourOpen, setIsLabourOpen] = useState(false)
  const [deleteInput, setDeleteInput] = useState('')
  const [customItemList, setCustomItemList] = useState([])
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const currentUser = useUserStore((store) => store.currentUser)

  const location = useLocation()
  const isAssignedToMe = location?.state?.isAssignedToMe
  const dataFromInvoiceScreen = location?.state?.dataFromInvoiceScreen
  const [isEmail, setIsEmail] = useState(false)
  const [emailContacts, setEmailContacts] = useState({})
  const [workorderPdf, setWorkorderPdf] = useState()
  const [workOrderData, setWorkOrderData] = useState({})
  const [QWIData, setQWIData] = useState()
  const setLoading = useLoadingStore((store) => store.setLoading)
  const isLoading = useLoadingStore((store) => store.loading)
  const [notes, setNotes] = useState({
    notes_external: workOrderData.notes_external || '',
    notes_internal: workOrderData.notes_internal || '',
    client_notes: workOrderData.client?.notes || ''
  })
  const [isServiceOnly, setIsServiceOnly] = useState(false)
  const [referralData, setReferralData] = useState()
  const textDisplay = { textAlign: 'center' }

  const history = useHistory()
  const setRevertedInvoice = useRevertedInvoice((store) => store.setRevertedInvoice)

  const redirectToForbiddenPage = () => {
    history.replace(REDIRECT_URLS.FORBIDDEN_PAGE)
  }

  const redirectPreCalibration = () => {
    history.push(getUrlByNameAndId(REDIRECT_URLS.WORK_ORDER_PRE_CALIBRATION, referenceNumber))
  }

  const redirectCalibration = () => {
    history.push(getUrlByNameAndId(REDIRECT_URLS.WORK_ORDER_CALIBRATION, referenceNumber))
  }
  const redirectPostCalibration = () => {
    history.push(getUrlByNameAndId(REDIRECT_URLS.WORK_ORDER_POST_CALIBRATION, referenceNumber))
  }
  const redirectVehicleInfo = () => {
    history.push(getUrlByNameAndId(REDIRECT_URLS.WORK_ORDER_VEHICLE_INFO, referenceNumber))
  }
  const redirectDocuments = () => {
    history.push(getUrlByNameAndId(REDIRECT_URLS.WORK_ORDER_DOCUMENT, referenceNumber))
  }

  const redirectPhotos = () => {
    history.push(getUrlByNameAndId(REDIRECT_URLS.WORK_ORDER_PHOTO, referenceNumber))
  }

  const saveNote = useCallback(
    async (notes) => {
      const isSuccess = (status) => status === 200 || status === 201

      if (notes.noteType === 'client_note') {
        const clientNotes = notes?.note?.client_notes
        const updatedClientData = {
          ...workOrderData.client,
          notes: clientNotes
        }

        const { status, data } = await updateClient({ data: updatedClientData })

        if (isSuccess(status)) {
          setNotes((prevNotes) => ({
            ...prevNotes,
            client_notes: data.notes
          }))
        }
      } else {
        const { status, data } = await updateNote({
          type: 'workorders',
          id: workOrderData.id,
          data: notes
        })

        if (isSuccess(status)) {
          const updatedWorkOrder = data.workOrder

          setNotes((prevNotes) => ({
            ...prevNotes,
            notes_external: updatedWorkOrder.notes_external,
            notes_internal: updatedWorkOrder.notes_internal,
            client_notes: workOrderData.client?.notes
          }))
        }
      }
    },
    [workOrderData.id, workOrderData.client]
  )
  const calculateTotal = (list = []) => list.reduce((sum, { total_price = 0 }) => sum + total_price, 0)
  const packagesTotal = useMemo(() => calculateTotal(packages), [packages])
  const servicesTotal = useMemo(() => calculateTotal(services), [services])
  const partsTotal = useMemo(() => calculateTotal(parts), [parts])
  const laborTotal = useMemo(() => calculateTotal(labor), [labor])

  const customItemTotal = useMemo(() => {
    return customItemList.length > 0
      ? customItemList.reduce((total_price, current) => {
          if (current.type === 'DISCOUNT') {
            return total_price - current.total_price
          } else {
            return total_price + current.total_price
          }
        }, 0)
      : 0
  }, [customItemList])

  const totalCost = useMemo(
    () => packagesTotal + servicesTotal + partsTotal + laborTotal + customItemTotal,
    [packagesTotal, servicesTotal, partsTotal, laborTotal, customItemTotal]
  )

  const [open, setOpen] = useState(false)
  const handleConfirm = async () => {
    const deleteWorkOrderResponse = deleteWorkOrder({
      workOrderId: workOrderData.id
    })
    deleteWorkOrderResponse
      .then(() => {
        setRevertedInvoice(undefined)
        history.push('/')
      })
      .catch((error) => console.log(error))
  }

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setDeleteInput('')
  }

  const handleAddToInvoice = async (shouldUpdateInvoice) => {
    try {
      const createInvoiceResponse = await convertWorkOrderToInvoice({
        workOrderId: workOrderData.id
      })

      if (createInvoiceResponse.status === 200) {
        const redirectPath = shouldUpdateInvoice ? getUrlByNameAndId(REDIRECT_URLS.INVOICE_SUMMARY, referenceNumber) : '/invoices'

        shouldUpdateInvoice ? history.push(redirectPath) : history.replace(redirectPath)
      }
    } catch (error) {
      Logger.error({ message: error, payload: { file: 'WorkOrderSummaryPage/handleAddToInvoice', workOrderId: workOrderData.id } })
    }
  }

  const convertServiceOnlyToStandardWo = useCallback(async () => {
    try {
      setShowConfirmModal(false)
      await convertToStandardWO(workOrderData.id)
      setIsServiceOnly(false)
    } catch (error) {
      Logger.error({
        message: error,
        payload: {
          file: 'WorkOrderSummaryPage/handleConvertToStandardWo',
          workOrderId: workOrderData.id
        }
      })
    }
  }, [workOrderData.id])

  const ConvertToStandardWoWithConfirmation = () => {
    setShowConfirmModal(true)
  }
  const onCloseCalibrations = (data) =>
    handleDrawerClose({
      setLoading,
      setDrawerOpen: setIsCalibrationOpen,
      updateFn: updateWorkOrderCalibrations,
      setItems: setPackages,
      sourceData: workOrderData,
      data,
      logFile: 'updateWorkOrderCalibrations',
      itemKey: 'calibrations',
      type: 'workorders',
      onSuccess: fetchData
    })

  const onCloseServices = (data) =>
    handleDrawerClose({
      setLoading,
      setDrawerOpen: setIsServiceOpen,
      updateFn: updateWorkOrderServices,
      setItems: setServices,
      sourceData: workOrderData,
      data,
      logFile: 'updateWorkOrderServices',
      itemKey: 'services',
      type: 'workorders',
      onSuccess: fetchData
    })

  const onCloseParts = (data) =>
    handleDrawerClose({
      setLoading,
      setDrawerOpen: setIsPartsOpen,
      updateFn: updateWorkOrderParts,
      setItems: setParts,
      sourceData: workOrderData,
      data,
      logFile: 'updateWorkOrderParts',
      itemKey: 'parts',
      type: 'workorders',
      onSuccess: fetchData
    })

  const onCloseLabour = (data) =>
    handleDrawerClose({
      setLoading,
      setDrawerOpen: setIsLabourOpen,
      updateFn: updateWorkOrderLabour,
      setItems: setLabor,
      sourceData: workOrderData,
      data,
      logFile: 'updateWorkOrderLabour',
      itemKey: 'labors',
      type: 'workorders',
      onSuccess: fetchData
    })

  const fetchData = async () => {
    try {
      setLoading(true)

      const loadWorkOrderData = async () => {
        const response = await getWorkOrderByReferenceNumber({ referenceNumber })
        if (response?.status !== 200) {
          redirectToForbiddenPage()
          return
        }

        const { data } = response
        const { workOrder } = data

        if (StatusEnum[workOrder?.status] === StatusEnum.MOVED) {
          redirectToForbiddenPage()
          return
        }

        // Attach additional data to workOrder
        Object.assign(workOrder, {
          safetySystemsItems: data.safetySystemsItems,
          calibrations: data.qwiCalibrations,
          services: data.qwiServices,
          parts: data.qwiParts,
          labors: data.qwiLabours,
          customItems: data.qwiCustomItems
        })

        setIsServiceOnly(workOrder.type === 'SERVICE_ONLY')
        setWorkOrderData(workOrder)
        const qwi_response = await getQWIByWorkOrderId(workOrder?.id)
        setQWIData(qwi_response.data)
        setNotes({
          notes_external: workOrder.notes_external || '',
          notes_internal: workOrder.notes_internal || '',
          client_notes: workOrder.client?.notes || ''
        })

        const selectedItemNums = {
          calibrations: [],
          services: [],
          parts: [],
          labours: []
        }

        if (data.qwiCalibrations?.length) {
          const flattened = data.qwiCalibrations.map((item) => flattenItem(item, 'calibration'))
          setPackages(flattened)
          selectedItemNums.calibrations = flattened.map((item) => item.itemNum)
        }

        if (data.qwiServices?.length) {
          const flattened = data.qwiServices.map((item) => flattenItem(item, 'service'))
          setServices(flattened)
          selectedItemNums.services = flattened.map((item) => item.itemNum)
        }

        if (data.qwiParts?.length) {
          const flattened = data.qwiParts.map((item) => flattenItem(item, 'part'))
          setParts(flattened)
          selectedItemNums.parts = flattened.map((item) => item.itemNum)
        }

        if (data.qwiLabours?.length) {
          const flattened = data.qwiLabours.map((item) => flattenItem(item, 'labour'))
          setLabor(flattened)
          selectedItemNums.labours = flattened.map((item) => item.itemNum)
        }

        if (data.qwiCustomItems?.length) {
          const updatedList = data.qwiCustomItems.map((item) => ({
            ...item,
            category_id: item.category?.id,
            price: item.cost_price
          }))
          setCustomItemList(updatedList)
        }

        if (dataFromInvoiceScreen) {
          setRevertedInvoice(workOrder)
        }
      }

      await loadWorkOrderData()
    } catch (error) {
      Logger.error({
        message: error,
        payload: {
          referenceNumber: workOrderData?.reference_number,
          ccid: workOrderData?.calibrationCenter?.id,
          effectiveDate: workOrderData?.quoteCreatedAt || workOrderData?.created_at
        }
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (referenceNumber) fetchData()
  }, [referenceNumber, isServiceOnly])

  useEffect(() => {
    setWorkOrderData((prev) => {
      const updated = {
        ...prev,
        customItems: customItemList
      }
      return updated
    })
  }, [customItemList])
  const {
    selectedProduct,
    setSelectedProduct,
    isOpenEditProduct,
    setIsOpenEditProduct,
    handleClickEditPricing,
    handleEditPricingInputChange,
    handleEditPricingSubmit
  } = useEditPricing(fetchData)

  const vehicleData = workOrderData?.vehicle || {}

  const showDeleteButton = useMemo(() => {
    return !dataFromInvoiceScreen || (dataFromInvoiceScreen && (currentUser.is_admin || currentUser.is_owner))
  }, [location, currentUser])

  const emailWorkorderHandler = useCallback(async () => {
    // setLoading(true)
    const params = {
      workOrderId: workOrderData?.id
    }
    try {
      const emailContactResponse = await getWorkorderEmailPreview(workOrderData?.id)
      if (emailContactResponse.status === 200) {
        setIsEmail(true)
        setEmailContacts(emailContactResponse.data)
      }
      const workorderPdfResponse = await getWorkorderPdf(workOrderData?.id)
      if (workorderPdfResponse.status === 200) {
        const fileValue = new File([workorderPdfResponse.data], `workorder_${workOrderData?.reference_number}.pdf`)
        fileValue.id = workOrderData?.id
        setWorkorderPdf(fileValue)
      }
    } catch (error) {
      Logger.error({ message: error, payload: { WorkorderId: workOrderData?.id, path: 'WorkorderPage/emailWorkorderHandler' } })
    }
  }, [workOrderData])

  const options = [
    {
      label: 'Email WO',
      action: emailWorkorderHandler,
      visible: true
    },
    {
      label: 'Support',
      action: () => history.push(REDIRECT_URLS.CREATE_SUPPORT_REQUEST, { referenceNumber }),
      visible: true
    },
    {
      label: 'Delete WO',
      action: handleOpen,
      visible: showDeleteButton,
      disabled: !currentUser.is_admin && !currentUser.is_owner && QWIData && QWIData.invoiceId ? true : false
    }
  ]

  const handleClickClosePricing = (type) => {
    setIsOpenEditProduct((prev) => ({ ...prev, [type]: false }))
    setSelectedProduct({})
  }
  const onSaveCustomItem = (props) => {
    setCustomItemList(props)
    fetchData()
  }
  const { populateSelectableItems } = itemHandlersFactory({
    getCalibrationList,
    getServiceList,
    getPartsList,
    getLabourList,
    setAvailableCalibrations,
    setAvailableServices,
    setAvailableParts,
    setAvailableLabour,
    transformToMap
  })
  const drawerSetters = {
    calibrations: setIsCalibrationOpen,
    services: setIsServiceOpen,
    parts: setIsPartsOpen,
    labor: setIsLabourOpen
  }

  const handleManageClick = async (type) => {
    const ccid = workOrderData?.calibrationCenter?.id
    const qwi_id = QWIData?.id

    const selected = {
      calibrations: packages,
      services: services,
      parts: parts,
      labours: labor
    }

    let extraParams = {}

    if (type !== 'parts' && referralData?.id) {
      extraParams = {
        belongsTo: 'REFERRAL',
        belongsToId: referralData.id
      }
    }

    await populateSelectableItems(type, ccid, qwi_id, selected, extraParams)
    drawerSetters[type]?.(true)
  }
  useEffect(() => {
    if (QWIData?.referralSourceCode) {
      const fetchReferralData = async () => {
        // Fetch referral data if referralSourceCode is present
        const referral_response = await getReferralByCode({
          ccId: workOrderData?.calibrationCenter?.id,
          code: QWIData?.referralSourceCode
        })
        setReferralData(referral_response.data)
      }
      fetchReferralData()
    }
  }, [QWIData?.referralSourceCode, workOrderData?.calibrationCenter?.id])

  return (
    <AdasContainer maxWidth='lg'>
      {workOrderData.id && (
        <AdasPaper elevation={0} sx={{ padding: '1.25rem', marginTop: '1.25rem', marginBottom: '60px' }}>
          <Drawers data={availableCalibrations} isOpen={isCalibrationOpen} onClose={onCloseCalibrations} title={'Calibrations'} />
          <Drawers data={availableServices} isOpen={isServiceOpen} onClose={onCloseServices} title={'Service'} />
          <Drawers data={availableParts} isOpen={isPartsOpen} onClose={onCloseParts} title={'Parts'} />
          <Drawers data={availableLabour} isOpen={isLabourOpen} onClose={onCloseLabour} title={'Labor'} />
          <AdasBox sx={{ marginBottom: '40px' }} key='section1'>
            <AdasBox sx={{ overflow: 'hidden' }} display='flex' justifyContent='space-between' flexDirection={{ xs: 'row' }}>
              <AdasBox mb={1}>
                <IdDisplay itemId={workOrderData.reference_number} roNumber={workOrderData.repair_order_num} itemType={'WO'} />
                {workOrderData.created_at && (
                  <AdasTypography variant='body2' color={'secondary'} sx={{ display: { xs: 'block', md: 'none' } }}>
                    Created: {new Date(workOrderData.created_at).toLocaleDateString('en-US')}
                  </AdasTypography>
                )}
              </AdasBox>
              <AdasBox display='flex' gap={1} alignItems='center' justifyContent='space-between'>
                <AssignedUser type='workorders' workOrderId={workOrderData.id} initialAssignee={workOrderData.assigned_to} />
                {workOrderData.created_at && (
                  <AdasTypography variant='body2' color={'secondary'} sx={{ display: { xs: 'none', md: 'block' } }}>
                    Created: {new Date(workOrderData.created_at).toLocaleDateString('en-US')}
                  </AdasTypography>
                )}
              </AdasBox>
            </AdasBox>

            <AdasBox
              style={{
                overflow: 'hidden',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                float: 'right',
                marginTop: '2px'
              }}
            >
              <span style={{ float: 'right', padding: '6px', paddingRight: 0 }}>
                <DropdownActionButtons options={options} />
              </span>
            </AdasBox>
            {vehicleData?.year && (
              <AdasBox id='carInfo' key='carInfo'>
                <AdasBox id='image'>
                  {vehicleData.image_url ? <AdasImage src={vehicleData.image_url} alt='vehicle' /> : <CarImageHolder showText={false} />}
                  <AdasTypography sx={{ ...textDisplay, fontSize: '24px' }}>
                    <b>{`${vehicleData.year} ${vehicleData.make} ${vehicleData.model} ${vehicleData.trim || ''}`}</b>
                  </AdasTypography>
                </AdasBox>
                <AdasTypography sx={{ ...textDisplay, fontSize: '20px', fontWeight: '500' }}>
                  <b>Total Cost: {currencyFormatter(totalCost)}</b>
                </AdasTypography>
              </AdasBox>
            )}
            <AdasBox id='clientInfo' sx={{ ...textDisplay }} key='clientInfo'>
              <AdasTypography sx={{ ...textDisplay }} color={theme.typography.secondaryColor}>
                {workOrderData.client?.name}
              </AdasTypography>
              {workOrderData.client?.rebate_percent !== 0 && workOrderData.client?.rebate_percent !== null && (
                <AdasTypography sx={{ ...textDisplay }} color={theme.typography.secondaryColor}>
                  Client Rebate: {workOrderData.client?.rebate_percent}%
                </AdasTypography>
              )}
            </AdasBox>
          </AdasBox>
          {!isLoading && (
            <>
              <AdasBox key='section2'>
                <AdasStepper orientation='vertical' connector={null} activeStep={-1}>
                  {!isServiceOnly && (
                    <AdasStep key='preCalibration'>
                      <AdasStepLabel>Complete Pre Calibration Set Up</AdasStepLabel>
                      {workOrderData.is_precalibration_complete ? (
                        <AdasPaper elevation={0}>
                          <AdasBox
                            sx={{
                              height: '50px',
                              border: '1px',
                              display: 'flex',
                              backgroundColor: '#D7E2FF',
                              alignItems: 'center',
                              paddingLeft: '20px',
                              borderRadius: '4px'
                            }}
                          >
                            <CheckCircleOutlineOutlinedIcon />
                            <AdasTypography sx={{ margin: '4px' }}>Pre Calibration Set Up Complete</AdasTypography>
                          </AdasBox>
                          <AdasBox sx={{ textAlign: 'end' }}>
                            <AdasButton sx={{}} onClick={redirectPreCalibration}>
                              REVIEW PRE CALIBRATION SET UP
                            </AdasButton>
                          </AdasBox>
                        </AdasPaper>
                      ) : (
                        <AdasPaper
                          variant='outlined'
                          sx={{
                            ...textDisplay,
                            backgroundColor: theme.palette.background.light
                          }}
                        >
                          <AdasButton
                            variant='outlined'
                            sx={{ width: '90%', margin: '20px 0px' }}
                            endIcon={<ArrowForwardIosIcon fontSize='small' />}
                            onClick={redirectPreCalibration}
                          >
                            Complete PRE CALIBRATION SET UP
                          </AdasButton>
                        </AdasPaper>
                      )}
                    </AdasStep>
                  )}
                  <AdasStep key='packagesx'>
                    <AdasStepLabel>Add/Remove {!isServiceOnly && 'Calibrations and '}Services</AdasStepLabel>
                    {QWIData?.referralSourceCode && <ProductContractBanner referralData={referralData} />}
                    <AdasPaper variant='outlined' sx={{ backgroundColor: theme.palette.background.light, border: 'none' }}>
                      {!isServiceOnly && (
                        <>
                          <ExpandableSection
                            type='calibration'
                            key='notServiceOnly'
                            title='Calibrations'
                            total={packagesTotal}
                            items={packages}
                            manageLabel='MANAGE CALIBRATIONS'
                            onManage={() => handleManageClick('calibrations')}
                            onEdit={handleClickEditPricing}
                          />
                          <EditProductPricing
                            key='edit calibration'
                            type='calibration'
                            title='Calibrations'
                            product={selectedProduct}
                            descriptionLength={MAX_DESCRIPTION_LENGTH}
                            isOpen={isOpenEditProduct.calibration}
                            onClose={handleClickClosePricing}
                            handleInputChange={handleEditPricingInputChange}
                            onSubmit={handleEditPricingSubmit}
                            isNational={QWIData?.referralSourceCode}
                          />
                          <AdasDivider orientation='horizontal' flexItem sx={{ margin: '5px' }} key='divider' />
                        </>
                      )}
                      <ExpandableSection
                        key='ServiceOnly'
                        title='Services'
                        total={servicesTotal}
                        items={services}
                        manageLabel='Manage Services'
                        onManage={() => handleManageClick('services')}
                        type={'service'}
                        onEdit={handleClickEditPricing}
                      />
                      <EditProductPricing
                        key='edit service'
                        type='service'
                        title='Services'
                        product={selectedProduct}
                        descriptionLength={MAX_DESCRIPTION_LENGTH}
                        isOpen={isOpenEditProduct.service}
                        onClose={handleClickClosePricing}
                        handleInputChange={handleEditPricingInputChange}
                        onSubmit={handleEditPricingSubmit}
                        isNational={QWIData?.referralSourceCode}
                      />
                      <AdasDivider orientation='horizontal' flexItem sx={{ margin: '0px 25px' }} />

                      <ExpandableSection
                        key='Parts'
                        title='Parts'
                        total={partsTotal}
                        items={parts}
                        manageLabel='Manage Parts'
                        onManage={() => handleManageClick('parts')}
                        type={'part'}
                        onEdit={handleClickEditPricing}
                      />
                      <EditProductPricing
                        key='edit part'
                        type='part'
                        title='Parts'
                        product={selectedProduct}
                        descriptionLength={MAX_DESCRIPTION_LENGTH}
                        isOpen={isOpenEditProduct.part}
                        onClose={handleClickClosePricing}
                        handleInputChange={handleEditPricingInputChange}
                        onSubmit={handleEditPricingSubmit}
                        isNational={QWIData?.referralSourceCode}
                      />
                      <AdasDivider orientation='horizontal' flexItem sx={{ margin: '0px 25px' }} />
                      <ExpandableSection
                        key='Labour'
                        title='Labor'
                        total={laborTotal}
                        items={labor}
                        manageLabel='Manage Labor'
                        onManage={() => handleManageClick('labor')}
                        type={'labor'}
                        onEdit={handleClickEditPricing}
                      />
                      <EditProductPricing
                        key='edit labor'
                        type='labor'
                        title='Labor'
                        product={selectedProduct}
                        descriptionLength={MAX_DESCRIPTION_LENGTH}
                        isOpen={isOpenEditProduct.labor}
                        onClose={handleClickClosePricing}
                        handleInputChange={handleEditPricingInputChange}
                        onSubmit={handleEditPricingSubmit}
                        isNational={QWIData?.referralSourceCode}
                      />
                      <AdasDivider orientation='horizontal' flexItem sx={{ margin: '0px 25px' }} />

                      <CustomItem
                        type='workorders'
                        customItemTotal={customItemTotal}
                        existingCustomItemList={customItemList}
                        workOrderData={workOrderData}
                        onSaveCustomItem={onSaveCustomItem}
                      />
                      <AdasDivider orientation='horizontal' flexItem sx={{ margin: '0px 25px' }} />
                      <AdasBox sx={{ display: 'flex', justifyContent: 'space-between', padding: '12px 50px' }}>
                        <AdasTypography sx={{ fontWeight: '600' }}>Total Cost</AdasTypography>
                        <AdasTypography sx={{ fontWeight: '600' }} mr='1.5rem'>
                          {currencyFormatter(totalCost)}
                        </AdasTypography>
                      </AdasBox>
                    </AdasPaper>
                  </AdasStep>
                  {!isServiceOnly && [
                    <AdasStep key='calibrationServiceOnly'>
                      <AdasStepLabel>Calibration Documentation</AdasStepLabel>
                      {workOrderData.is_calibration_step_complete ? (
                        <AdasPaper elevation={0}>
                          <AdasBox
                            sx={{
                              height: '50px',
                              border: '1px',
                              display: 'flex',
                              backgroundColor: '#D7E2FF',
                              alignItems: 'center',
                              paddingLeft: '20px',
                              borderRadius: '4px'
                            }}
                          >
                            <CheckCircleOutlineOutlinedIcon />
                            <AdasTypography sx={{ margin: '4px' }}>Calibration Documentation Complete</AdasTypography>
                          </AdasBox>
                          <AdasBox sx={{ textAlign: 'end' }}>
                            <AdasButton sx={{}} onClick={redirectCalibration}>
                              REVIEW CALIBRATION DOCUMENTATION
                            </AdasButton>
                          </AdasBox>
                        </AdasPaper>
                      ) : (
                        <AdasPaper
                          variant='outlined'
                          sx={{
                            ...textDisplay,
                            backgroundColor: theme.palette.background.light
                          }}
                        >
                          <AdasButton
                            variant='outlined'
                            sx={{ width: '90%', margin: '20px 0px' }}
                            endIcon={<ArrowForwardIosIcon fontSize='small' />}
                            onClick={redirectCalibration}
                          >
                            CALIBRATION SET UP
                          </AdasButton>
                        </AdasPaper>
                      )}
                    </AdasStep>,
                    <AdasStep key='postCalibration'>
                      <AdasStepLabel>Post Calibration Checklist</AdasStepLabel>
                      {workOrderData.is_postcalibration_complete ? (
                        <AdasPaper elevation={0}>
                          <AdasBox
                            sx={{
                              height: '50px',
                              border: '1px',
                              display: 'flex',
                              backgroundColor: '#D7E2FF',
                              alignItems: 'center',
                              paddingLeft: '20px',
                              borderRadius: '4px'
                            }}
                          >
                            <CheckCircleOutlineOutlinedIcon />
                            <AdasTypography sx={{ margin: '4px' }}>Post Calibration Set Up Complete</AdasTypography>
                          </AdasBox>
                          <AdasBox sx={{ textAlign: 'end' }}>
                            <AdasButton sx={{}} onClick={redirectPostCalibration}>
                              REVIEW POST CALIBRATION SET UP
                            </AdasButton>
                          </AdasBox>
                        </AdasPaper>
                      ) : (
                        <AdasPaper
                          variant='outlined'
                          sx={{
                            ...textDisplay,
                            backgroundColor: theme.palette.background.light
                          }}
                        >
                          <AdasButton
                            variant='outlined'
                            sx={{ width: '90%', margin: '20px 0px' }}
                            endIcon={<ArrowForwardIosIcon fontSize='small' />}
                            onClick={redirectPostCalibration}
                          >
                            COMPLETE POST CALIBRATION SET UP
                          </AdasButton>
                        </AdasPaper>
                      )}
                    </AdasStep>
                  ]}
                  <AdasStep key='notesServiceOnly'>
                    <AdasStepLabel>Notes</AdasStepLabel>
                    <Note
                      existingExternalNote={notes.notes_external}
                      existingInternalNote={notes.notes_internal}
                      existingClientNote={notes.client_notes}
                      submit={(props) => saveNote(props)}
                      allowEdit={true}
                      clientRebate={workOrderData.client?.rebate_percent}
                    />
                  </AdasStep>
                </AdasStepper>
              </AdasBox>
            </>
          )}
          <AdasBox sx={{ margin: '10px 0px' }} key='section3'>
            <AdasStack
              direction='row'
              spacing={1}
              divider={<AdasDivider orientation='vertical' flexItem sx={{ backgroundColor: '#0071E3' }} />}
            >
              <AdasButton onClick={redirectVehicleInfo} startIcon={<InfoOutlinedIcon fontSize='small' />} sx={{ width: { sm: '30%' } }}>
                <AdasTypography variant='body2' sx={{ textWrap: 'nowrap' }}>
                  Vehicle Info
                </AdasTypography>
              </AdasButton>
              <AdasButton startIcon={<PhotoCameraOutlinedIcon />} onClick={redirectPhotos} sx={{ width: { sm: '30%' } }}>
                <AdasTypography variant='body2'>Photos</AdasTypography>
              </AdasButton>
              <AdasButton startIcon={<InsertDriveFileOutlinedIcon />} onClick={redirectDocuments} sx={{ width: { sm: '30%' } }}>
                <AdasTypography variant='body2'>Documents</AdasTypography>
              </AdasButton>
            </AdasStack>
            <AdasDivider orientation='horizontal' flexItem sx={{ marginTop: '10px' }} />
          </AdasBox>
          <AdasBox sx={{ marginBottom: '20px' }} key='section4'>
            <AdasBox
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: { xs: 'column', sm: 'row' },
                ml: { sm: 'auto' }
              }}
            >
              <AdasButton
                startIcon={<KeyboardDoubleArrowLeftIcon />}
                onClick={() => history.push('/workorders', { isAssignedToMe: isAssignedToMe })}
                sx={{ alignSelf: { xs: 'flex-start', sm: 'center' } }}
              >
                Work Orders
              </AdasButton>

              <AdasBox
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'row', md: 'row', sm: 'column' },
                  gap: { xs: '1rem', sm: '0' },
                  ml: { sm: 'auto' }
                }}
              >
                {isServiceOnly && !QWIData?.invoiceId && (
                  <AdasButton startIcon={<SyncAltOutlined />} onClick={ConvertToStandardWoWithConfirmation}>
                    Add Calibrations
                  </AdasButton>
                )}
              </AdasBox>

              <AdasButton
                variant='contained'
                startIcon={<AddOutlinedIcon />}
                sx={{ marginLeft: { sm: '2rem' }, marginTop: '11px', marginBottom: '11px' }}
                isDebounceEnabled={true}
                disabled={
                  !isServiceOnly &&
                  !(
                    workOrderData.is_precalibration_complete &&
                    workOrderData.is_postcalibration_complete &&
                    workOrderData.is_calibration_step_complete
                  )
                }
                onClick={() => handleAddToInvoice(dataFromInvoiceScreen)}
              >
                {dataFromInvoiceScreen ? 'Update Invoice' : 'Add To Invoice'}
              </AdasButton>
            </AdasBox>

            <AdasModal
              open={open}
              onClose={handleClose}
              aria-labelledby='modal-modal-title'
              aria-describedby='modal-modal-description'
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <AdasPaper
                variant='outlined'
                sx={{
                  paddingLeft: '20px',
                  paddingRight: '20px',
                  paddingBottom: '20px'
                }}
              >
                <h2>Delete Work Order?</h2>
                <p>To confirm that you want to delete this work order, type DELETE below.</p>
                <AdasTextField
                  onChange={(e) => setDeleteInput(e.target.value.toUpperCase())}
                  name='deleteInput'
                  sx={{ marginBottom: '20px' }}
                  id='deleteInput'
                  label='Delete Input'
                  variant='outlined'
                  value={deleteInput}
                  fullWidth={true}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <AdasBox sx={{ display: 'flex' }}>
                  <AdasButton variant='outlined' sx={{ marginLeft: 'auto', mr: '5px' }} onClick={handleClose}>
                    Cancel
                  </AdasButton>
                  <AdasButton variant='contained' disabled={deleteInput === 'DELETE' ? false : true} onClick={handleConfirm}>
                    Delete
                  </AdasButton>
                </AdasBox>
              </AdasPaper>
            </AdasModal>
            {showConfirmModal && (
              <ConfirmModal
                cancelLabel={BUTTONS_DISPLAY_LABEL.CANCEL}
                confirmLabel={BUTTONS_DISPLAY_LABEL.CONFIRM}
                open={showConfirmModal}
                title={GENERIC_MESSAGES.ADD_CALIBRATIONS}
                message={GENERIC_MESSAGES.CLICK_CONFIRM_SERVICE_ONLY_WO_TO_STANDARD_WO_MESSAGE}
                handleClose={() => setShowConfirmModal(false)}
                handleContinue={convertServiceOnlyToStandardWo}
              />
            )}
          </AdasBox>
        </AdasPaper>
      )}

      <EmailForm
        workOrderPdf={workorderPdf}
        isOpen={isEmail}
        contacts={emailContacts}
        emailData={workOrderData}
        onClose={() => setIsEmail(false)}
      />
    </AdasContainer>
  )
}
